const additionalAlertTroubleshootingContext = `
# Investigate this Alert by collecting all relevant information through available data sources:

1. Correlate it with other Alerts occurring at similar times
2. Collect all relevant data from available and related data sources for 1 hour before the Alert (and 1 hour after if it is cleared). Collect data for the current time frame when necessary.
3. Focus on identifying the potential root cause of the issue
4. Perform impact analysis:
   - How does this Alert affect the rest of the network?
   - What is the impact on traffic and performance?
   - Are there any alternative traffic routes in use or backup devices and/or links?
5. Perform any other necessary troubleshooting steps, including asking the user for additional information or clarifications if needed
6. Provide a brief summary of findings at the end and ask users if they have any guidance on additional steps to perform
`;

const KAIZEN_EVENT_TYPES = {
  AGENT_INITIALIZED: 'agent_initialized',
  CHAT_SESSION_UPDATED: 'chat_session_updated',
  AGENT_TURN_STARTED: 'agent_turn_started',
  AGENT_STEP_STARTED: 'agent_step_started',
  AGENT_STEP_UPDATED: 'agent_step_updated',
  TOOL_CALL_STARTED: 'tool_call_started',
  TOOL_CALL_SUCCEEDED: 'tool_call_succeeded',
  TOOL_CALL_FAILED: 'tool_call_failed',
  TOOL_CALL_AWAITING_APPROVAL: 'tool_call_awaiting_approval',
  TOOL_CALL_APPROVED: 'tool_call_approved',
  TOOL_CALL_REJECTED: 'tool_call_rejected',
  AGENT_STEP_COMPLETED: 'agent_step_completed',
  AGENT_TURN_COMPLETED: 'agent_turn_completed',
  AGENT_TURN_FAILED: 'agent_turn_failed',
  CHAT_MESSAGE_CREATED: 'chat_message_created'
};

const PENDING = 'PENDING';
const PROCESSING = 'PROCESSING';
const COMPLETED = 'COMPLETED';
const FAILED = 'FAILED';

const AGENT_TURN_STATUS_TYPES = {
  PENDING,
  PROCESSING,
  COMPLETED,
  FAILED
};

const AGENT_TURN_STATUS_ACTIVE = [PENDING, PROCESSING];
const AGENT_TURN_STATUS_DONE = [COMPLETED, FAILED];
const AGENT_TURN_STATUS = [...AGENT_TURN_STATUS_ACTIVE, ...AGENT_TURN_STATUS_DONE];

const TOOL_CALL_STATUS = {
  PENDING: 'PENDING',
  SUCCESS: 'SUCCESS',
  FAILED: 'FAILED',
  TIMED_OUT: 'TIMED_OUT',
  AWAITING_APPROVAL: 'AWAITING_APPROVAL',
  USER_APPROVED: 'USER_APPROVED',
  USER_REJECTED: 'USER_REJECTED',
  APPROVAL_TIMEOUT: 'APPROVAL_TIMEOUT'
};

module.exports = {
  additionalAlertTroubleshootingContext,
  KAIZEN_EVENT_TYPES,
  AGENT_TURN_STATUS,
  AGENT_TURN_STATUS_ACTIVE,
  AGENT_TURN_STATUS_DONE,
  AGENT_TURN_STATUS_TYPES,
  TOOL_CALL_STATUS
};
